export default {
    COPPER: 'copper',
    ALUMINUM: 'aluminum',
    KNOB_TUBE: 'knob-tube',
    MIX: 'mix',
    UNKNOWN: 'unknown',
};
